
export class SearchTarget {
	id: String;
    name: String;
    children: SearchTarget[];
    hasChildren: boolean;
    attrs: any;

	constructor(obj?: any) {
		const target = obj || {};

		Object.assign(this, target);
		this.children = target.children ? target.children.map(c => new SearchTarget(c)) : [];
	}
}